import axios, { AxiosInstance } from "axios";
import { getToken } from "./tokenStore";

const API: AxiosInstance = axios.create({
  baseURL: `${process.env.REACT_APP_BASE_API_URL}/`,
  headers: {
    "Content-Type": "application/json",
  },
});

API.interceptors.request.use(
  (config) => {
    const token = getToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

API.interceptors.response.use(
  (response) => {
    // You can modify the response data here
    return response;
  },
  (error) => {
    console.log("error", error.message);
    return error;
  }
);

export default API;
